module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8yiHS"))).then(() => parcelRequire('hEqeo'));